import(/* webpackMode: "eager" */ "/vercel/path1/app/global-error.tsx");
